import React from 'react'
import '../ui.css'

const Button = React.forwardRef(function Button(
    {
        variant = 'primary', // primary | secondary | auth | icon
        provider, // fb | email | twitter (only for auth)
        size = 'md', // sm | md | lg
        className = '',
        type = 'button',
        disabled = false,
        ...props
    },
    ref
) {
    const classes = [
        'btn',
        `btn--${variant}`,
        `btn--${size}`,
        variant === 'auth' && provider ? `btn--${provider}` : '',
        disabled ? 'btn--disabled' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <button ref={ref} type={type} className={classes} disabled={disabled} {...props} />
    )
})

export default Button
